import {
  Box,
  CHART_COLOR_NAMES,
  PieChart,
  PieChartTooltipType,
} from '@factorialco/deprecated-design-system'

import useMouseCoords from 'modules/core/hooks/useMouseCoords'
import i18n from 'modules/core/lib/i18n'

import DraggableNode from '../../../../core/components/DraggableNode'
import ChartTooltip from '../../ChartTooltip'
import ChartTooltipPercentage from '../../ChartTooltipPercentage'
import TooltipLegend from '../../TooltipLegend'

type Datum = { label: string; value: number }

type Props = {
  data: Datum[]
}
const TooltipContainer = ({ data, total }: { total: number; data: Datum[] }) => {
  const Tooltip = ({ label, value }: PieChartTooltipType) => {
    const coordinates = useMouseCoords()

    return (
      <DraggableNode coordinates={coordinates}>
        <ChartTooltip title={i18n.t('insights.widgets.shared.headcount')}>
          <TooltipLegend
            color={CHART_COLOR_NAMES[data.findIndex((d) => label === d.label)]!}
            name={label.toString()}
            value={value}
          />
          {<ChartTooltipPercentage percentage={(value / total) * 100} />}
        </ChartTooltip>
      </DraggableNode>
    )
  }

  return Tooltip
}

const HeadcountByGenderChart = ({ data }: Props) => {
  const total = data.reduce((acc, datum) => acc + datum.value, 0)
  const Tooltip = TooltipContainer({ data, total })

  return (
    <Box height="s200" width="s300">
      <PieChart
        margin={{ top: 10, right: 0, bottom: 10, left: 0 }}
        data={data}
        tooltip={Tooltip}
        centeredMetricLabel={i18n.t('insights.widgets.shared.total')}
      />
    </Box>
  )
}

export default HeadcountByGenderChart
